<template lang="html">
    <div class="main">
        <!-- <img src="../asssts/download/download_bg1.png" alt=""> -->
        <!-- <img class="download-title" src="../assets/download/down_load_title.png" alt=""> -->
        <h1 class="downloaarticle-main-title">Congratulations!</h1>
        <p class="download-article">
            You have downloaded All Football App, which is the updated version of this website and will provide you with
            better using experience.
        </p>
        <p class="download-article">
            <b class="download-article-bold">Below are some introductions to how to install our App.</b>
        </p>
        <h2 class="downloaarticle-title">1. Download the app</h2>
        <p class="download-article" v-if="!is_opreamini">
            If you accidentally cancel the download, you can click on the link below to re-download it.
        </p>
        <img @click="jumpUrl" class="download-btn" src="../assets/download/download_btn.png" />
        <p class="download-article">
            If the usual warning about possible device damage appears, confirm <b class="green">"OK"</b> - we guarantee
            that our app will definitely not harm your device.
        </p>
        <img src="../assets/download/download_pic1.png" alt="">
        <h2 class="downloaarticle-title">2. Adjust the phone's setup</h2>
        <p class="download-article">
            You'll find the downloaded app in <b class="green">"Notifications"</b> or in the <b
            class="green">"Download"</b> folder. Click on it, choose <b class="green">"Install"</b> and confirm.
        </p>
        <img src="../assets/download/download_pic2.png" alt="">
        <h2 class="downloaarticle-title">3. Install the app</h2>
        <p class="download-article">
            You'll find the downloaded app in <b class="green">"Notifications"</b> or in the <b
            class="green">"Download"</b> folder. Click on it, choose <b class="green">"Install"</b> and confirm.
        </p>
        <img src="../assets/download/download_pic3.png" alt="">
        <div class="download-bottom">
            <h2 class="downloaarticle-title">Did not work?</h2>
            <p class="download-article">
                Try it once again following the instructions above. Or download the latest app version from <a
                href="https://at.umeng.com/SbK5Lf"><b class="green">Google_Play</b></a>.
            </p>
        </div>
    </div>
</template>

<script>
import { record, getQueryString } from '../util/util';

export default {
    data () {
        return {
            is_opreamini: false
        };
    },
    mounted () {
        record(`msite/download?from=${getQueryString('from')}`);
        ga('send', 'event', 'downloadPage', 'enter', getQueryString('from'));
        let utilObj = require('@/util/util.js');
        if (!utilObj.checkOperamini()) {
            this.jumpUrl();
        }
        this.is_opreamini = utilObj.checkOperamini();

        const isTryAwakeUp = getQueryString('type').startsWith('allfootball')
        if (!isTryAwakeUp) return

        // ios 拉起app失败跳转应用商店
        this.fallbackToApp()
    },

    methods: {
        jumpUrl () {
            let utilObj = require('@/util/util.js');
            utilObj.jumpUrl(true);
        },

        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        },

        async fallbackToApp() {
            await this.sleep(25)

            const userAgent = navigator.userAgent.toLowerCase()
            const isIos = /iphone|ipad|ipod|ios/.test(userAgent)

            if (!isIos) return

            const url = 'https://apps.apple.com/id/app/all-football-scores-news/id1171012600'
            window.location.href = url

            await this.sleep(1200)
            window.history.go(-1)
        }
    }
};
</script>

<style lang="css" scoped>
    .main {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
    }

    img {
        display: block;
        margin: 0;
    }

    .downloaarticle-main-title {
        padding-bottom: 22px;
        margin-top: 25px;
        color: #16ac3a;
        font-size: 31px;
        font-weight: 800;
        text-align: center;
    }

    .download-article-bold {
        display: inline-block;
        width: 270px;
        margin-bottom: 17px;
    }

    .download-title {
        width: 175px;
        margin: 0 auto;
        margin-top: 10px;
    }

    .downloaarticle-title {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
        padding: 22px 0;
        color: #16ac3a;
        font-size: 24px;
        font-weight: 800;
        text-align: center;
    }

    .downloaarticle-title:first-of-type {
        border-top: 1px solid #f4f6f8;
    }

    .download-btn {
        width: 150px;
        height: 45px;
        margin: 0 auto;
        margin-bottom: 20px;
        margin-top: 10px;
    }

    .download-article {
        padding: 0 10px 10px;
        color: #2d2f32;
        font-size: 16px;
        text-align: center;
    }

    .download-article:first-of-type {
        padding: 0 10px 26px 10px;

    }

    .download-article .green {
        color: #16ac3a;
    }

    .download-bottom {
        background: #eff1f4;
        margin-top: -1px;
    }
</style>



// WEBPACK FOOTER //
// AppDownload.vue?0c58dd4e